import React, { SyntheticEvent } from 'react';
import { useApolloClient, useQuery } from '@apollo/client';

import { Checkbox } from '@trqk/components';
import { queryStrings } from '@trqk/resolvers';

const { GET_STATEMENTS_UI_STATE } = queryStrings;

export const UploadHasStarted = (): JSX.Element => {
    const client = useApolloClient();
    const statementsUiStateQuery = useQuery(GET_STATEMENTS_UI_STATE);
    const showUploadHasStarted =
        statementsUiStateQuery?.data?.uiState?.statements
            ?.showUploadHasStarted ?? false;

    return (
        <div style={{ width: 410 }} className="px-2">
            <div className="font-bold text-primary-500 text-sm tracking-wider mb-2">
                Tip: Go explore Trqk while you wait.
            </div>
            <div className="font-bold mb-2">
                Uploads continue in the background
            </div>
            <div className="font-normal text-tertiary-500">
                We&lsquo;ll let you know when your statements are ready to
                explore.
            </div>
            <div className="mt-4">
                <Checkbox
                    addClasses="text-tertiary-400"
                    checked={showUploadHasStarted}
                    size="small"
                    inputId="show-upload-has-started"
                    label="Hide this notification"
                    onChange={(e: SyntheticEvent): void => {
                        const target = e.target as HTMLInputElement;

                        if (target.checked) {
                            client.writeQuery({
                                query: GET_STATEMENTS_UI_STATE,
                                data: {
                                    uiState: {
                                        __typename: 'UIState',
                                        statements: {
                                            __typename: 'Statements',
                                            showUploadHasStarted: false,
                                        },
                                    },
                                },
                            });
                        } else {
                            client.writeQuery({
                                query: GET_STATEMENTS_UI_STATE,
                                data: {
                                    uiState: {
                                        __typename: 'UIState',
                                        statements: {
                                            __typename: 'Statements',
                                            showUploadHasStarted: true,
                                        },
                                    },
                                },
                            });
                        }
                    }}
                />
            </div>
        </div>
    );
};
